var render = function render(){var _vm=this,_c=_vm._self._c;return _c('s-field',{staticClass:"alt-form-style s-timepicker"},[_c('input',{attrs:{"placeholder":_vm.placeholder}})])
}
var staticRenderFns = []

export { render, staticRenderFns }